const state = {
  piCompletionRate: null,
  piKxb: null,
  piOilBigType: null
}

const getters = {
  piCompletionRate: state => state.piCompletionRate,
  piKxb: state => state.piKxb,
  piOilBigType: state => state.piOilBigType
}

const actions = {
  setPiCompletionRater ({ commit }, data) {
    commit('setPiCompletionRater', data)
  },
  setPiKxb ({ commit }, data) {
    commit('setPiKxb', data)
  },
  setPiOilBigType ({ commit }, data) {
    commit('setPiOilBigType', data)
  }
}

const mutations = {
  setPiCompletionRater (state, data) {
    state.piCompletionRate = data
  },
  setPiKxb (state, data) {
    state.piKxb = data
  },
  setPiOilBigType (state, data) {
    state.piOilBigType = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/pi/pi_search_block.js